module.exports = __webpack_public_path__ + "img/phone.7bf64b03.svg";